import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';

export const StyledTabs = withStyles({
  indicator: {
    backgroundColor: '#E7474E',
  },
})(Tabs);
